import React from 'react';
import { Provider } from 'react-redux';
import { createStore as reductCreateStore } from "redux";
import rootReducer from ".";

const createStore = () => reductCreateStore(rootReducer);

export default ({ element }) => (
    <Provider store={ createStore() }> { element }</Provider>
)